import { BooleanInput, coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";
import { UntilDestroy } from "@ngneat/until-destroy";

interface TestComponentState {
    isTest: boolean;
}

@UntilDestroy()
@Component({
    selector: "hdtk-lib-test",
    templateUrl: "./test.component.html",
    styleUrls: ["./test.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class TestComponent {
    protected readonly isTest$ = this.localStore.selectByKey("isTest");

    @Input() public set isTest(value: BooleanInput) {
        this.localStore.patchState({ isTest: coerceBooleanProperty(value) });
    }

    constructor(private readonly localStore: LocalComponentStore<TestComponentState>) {
        this.localStore.setState({
            isTest: false,
        });
    }
}
